module.exports = __webpack_public_path__ + "media/images/banner-c8f4f3a1d58261228b96abcf6aa42fd0.png";